// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3C3pC","col":"styles_col__1-4fz","fulfillmentStatus":"styles_fulfillmentStatus__1t8fc","emailCol":"styles_emailCol__bx_7_"};